import React from 'react';
import PropTypes from 'prop-types';

import { useAllPlacementsPanel } from './all-placements-panel';
import { FooterButton } from './footer-button';

const AllPlacementsCore = ({
  index,
  getSelectedImage,
  previewElements,
  getImageInfoByIndex,
  getCarouselTitleByIndex,
  isImageValid,
  getIsRequiredByIndex,
  getMinSizeByIndex,
  headerButtonProps,
  styleOverrides,
  shouldHideHeaderButtonsByIndex,
  getTemplateTypeByIndex,
}) => {
  const { panelElement, footerButtonProps } = useAllPlacementsPanel({
    previewElements,
    getImageInfoByIndex,
    headerButtonProps,
    getCarouselTitleByIndex,
    isImageValid,
    getIsRequiredByIndex,
    getMinSizeByIndex,
    styleOverrides,
    shouldHideHeaderButtonsByIndex,
    getSelectedImage,
    getTemplateTypeByIndex,
  });

  return (
    <React.Fragment>
      <FooterButton
        index={index}
        selectedImage={getSelectedImage(index)}
        footerButtonProps={footerButtonProps}
        styleOverrides={styleOverrides}
      />
      { panelElement }
    </React.Fragment>
  );
};

AllPlacementsCore.propTypes = {
  index: PropTypes.number.isRequired,
  getSelectedImage: PropTypes.func.isRequired,
  previewElements: PropTypes.arrayOf(PropTypes.func).isRequired,
  getImageInfoByIndex: PropTypes.func.isRequired,
  getCarouselTitleByIndex: PropTypes.func.isRequired,
  isImageValid: PropTypes.bool.isRequired,
  getMinSizeByIndex: PropTypes.func.isRequired,
  getIsRequiredByIndex: PropTypes.func.isRequired,
  shouldHideHeaderButtonsByIndex: PropTypes.func.isRequired,
  getTemplateTypeByIndex: PropTypes.func.isRequired,
  headerButtonProps: PropTypes.shape({}),
  styleOverrides: PropTypes.shape({}),
};

AllPlacementsCore.defaultProps = {
  headerButtonProps: null,
  styleOverrides: {},
};

export const AllPlacements = (props) => {
  const { enableAllPlacementsPanel } = props;

  if (enableAllPlacementsPanel) {
    return (
      <AllPlacementsCore
        {...props}
      />
    );
  }

  return null;
};

AllPlacements.propTypes = {
  enableAllPlacementsPanel: PropTypes.bool,
};

AllPlacements.defaultProps = {
  enableAllPlacementsPanel: false,
};
